var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart2Cyclist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "37px",
    viewBox: "0 0 36 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-13.3%",
    width: "133.3%",
    height: "133.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-21.1%",
    y: "-23.5%",
    width: "142.1%",
    height: "147.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-6",
    transform: "translate(-427.000000, -212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(430.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5684F8",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bicycle-rider-copy",
    filter: "url(#filter-3)",
    transform: "translate(6.000000, 7.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2434042,3.23716488 C13.0573933,3.72400903 14.1057637,3.44688903 14.583453,2.61955387 C15.0623842,1.79198195 14.7910934,0.726551664 13.9771043,0.240023187 C13.161718,-0.246584209 12.1145507,0.0302201116 11.6362405,0.857555277 C11.1579302,1.68552178 11.4286001,2.75055748 12.2434042,3.23716488 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1880761,9.26089899 C15.0948027,9.26089899 15.0026112,9.26850803 14.9110764,9.2750973 L14.3534837,6.46661584 L14.5351621,6.39770303 C14.9472808,6.24132546 15.1569721,5.77533051 15.0026112,5.3567548 C14.8482888,4.93782608 14.386481,4.72591036 13.977492,4.88256248 L11.9751269,5.64268217 L11.8854469,4.90280096 C12.1288697,4.38534693 12.099543,3.7347739 11.701257,3.27579966 C10.8811926,2.33086655 9.88060894,2.78521261 9.56875728,3.04140981 L5.43891552,6.43625812 L5.43953373,6.43719944 C5.31129242,6.55066829 5.20426366,6.69155322 5.13583481,6.86244287 C5.05117776,7.07408404 5.03552915,7.29651123 5.07540413,7.50505387 C4.74686062,7.5312933 4.48597319,7.80200259 4.48597319,8.14225225 C4.48597319,8.49858287 4.76981191,8.78705967 5.12088169,8.78862854 L4.85825553,9.41249148 C4.52519131,9.31580959 4.17535797,9.26085976 3.81246479,9.26085976 C1.71052819,9.26089899 0,10.9965448 0,13.1302142 C0,15.2640011 1.71052819,16.9999608 3.81238752,16.9999608 C5.91444004,16.9999608 7.62415682,15.2640011 7.62415682,13.1302142 C7.62415682,11.7092845 6.86363442,10.468344 5.736355,9.79541453 L6.15971749,8.78929531 L6.84620844,8.78929531 L9.1753783,9.74874051 L7.93117866,11.8185959 C7.61059469,12.3524839 7.77685633,13.0494563 8.30268823,13.3751155 C8.48394162,13.48729 8.68435973,13.5409847 8.88226633,13.5409847 C9.25818069,13.5409847 9.62544002,13.3476602 9.8357496,12.9982326 L10.9693657,11.1118571 L11.70628,11.56334 C11.4958159,12.0429057 11.3763068,12.5723616 11.3763068,13.1302534 C11.3763068,15.2640404 13.0862168,17 15.1880761,17 C17.29009,17 19,15.2640404 19,13.1302534 C19,10.9965448 17.29009,9.26089899 15.1880761,9.26089899 Z M3.81238752,16.0293766 C2.23763516,16.0293766 0.956110685,14.7287404 0.956110685,13.1302142 C0.956110685,11.5316879 2.23763516,10.2313655 3.81238752,10.2313655 C4.042055,10.2313655 4.26248787,10.2665083 4.47650675,10.318595 L3.68534399,12.1970476 C3.23103204,12.2605478 2.88000089,12.6519428 2.88000089,13.1302142 C2.88000089,13.652767 3.29760624,14.0767161 3.81234888,14.0767161 C4.15109296,14.0767161 4.44474587,13.8906084 4.60787779,13.615467 L6.6195934,13.615467 C6.39062141,14.9828196 5.22346702,16.0293766 3.81238752,16.0293766 Z M6.61963204,12.6450005 L4.60791643,12.6450005 C4.59419974,12.621938 4.58056034,12.5988756 4.56495037,12.5770682 L5.35611313,10.6983018 C6.01520935,11.1307621 6.48327663,11.8296564 6.61963204,12.6450005 Z M11.4671847,10.2835306 L11.7633877,9.79074713 C11.9340155,9.50705539 11.9732337,9.1617069 11.8705711,8.84612779 C11.7677539,8.53054869 11.5337203,8.27682246 11.2306395,8.15174394 L9.1934225,7.31259219 L10.4469727,6.28180242 L10.5166766,6.8580108 C10.5458873,7.10381422 10.6853725,7.32243688 10.8938274,7.45104536 C11.0202141,7.52874387 11.1634858,7.56824029 11.3071825,7.56824029 C11.4012673,7.56824029 11.4957386,7.55117878 11.5860755,7.51701654 L13.4465212,6.81098379 L13.9730486,9.46595088 C13.2671997,9.707636 12.6548175,10.1527257 12.2015488,10.7333661 L11.4671847,10.2835306 Z M14.5047536,12.1449218 L13.0363731,11.2451722 C13.3407289,10.8875473 13.7236368,10.6051107 14.1648117,10.4319461 L14.5047536,12.1449218 Z M15.1880761,16.0293766 C13.6132852,16.0293766 12.3324175,14.7287404 12.3324175,13.1302142 C12.3324175,12.7558807 12.4083423,12.4008052 12.5359654,12.0718906 L14.2569646,13.1264881 C14.2569646,13.1277432 14.2563464,13.1289983 14.2563464,13.1302142 C14.2563464,13.652767 14.6739517,14.0767161 15.1880761,14.0767161 C15.7028188,14.0767161 16.1199605,13.6527278 16.1199605,13.1302142 C16.1199605,12.7192475 15.8602708,12.3729577 15.4994255,12.2422312 L15.1023372,10.2402297 C15.131548,10.2392883 15.1588654,10.2313655 15.1881148,10.2313655 C16.7629058,10.2313655 18.043928,11.5316879 18.043928,13.1302142 C18.0438893,14.7287404 16.7628671,16.0293766 15.1880761,16.0293766 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2Cyclist);
export default __webpack_public_path__ + "static/media/chart2-cyclist.b68c3d5c75e4fa49ea7abd280219b948.svg";
export { ForwardRef as ReactComponent };